import { render, staticRenderFns } from "./ItemPopover.vue?vue&type=template&id=5809f5ff&"
import script from "./ItemPopover.vue?vue&type=script&lang=js&"
export * from "./ItemPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports